export const inboundLeadEmailOutcomes = [
    "pending",
    "created",
    "noData",
    "failed",
    "forwardingConfirmation",
];
export const unconvertedInboundLeadEmailOutcomes = ["noData", "failed"];
//# sourceMappingURL=inbound-lead-email-outcome.js.map